import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import { createUnknownComponentVNode as _$cc, createElementVNode as _$ce, className as _$cn, noop as _$no, extend as _$ex, EMPTY_OBJ as _$em, map as _$ma } from 'intact-vue-next';
import { getClassAndStyleForFixed } from './useFixedColumns';
import { Dropdown, DropdownMenu, DropdownItem } from '../dropdown';
import { Button } from '../button';
import { Icon } from '../icon';
import { Checkbox } from '../checkbox';
import { makeGroupMenuStyles } from './styles';
import { isStringOrNumber, get, isArray } from 'intact-shared';
import { context as GroupContext } from './useGroup';
import { context as SortableContext } from './useSortable';
import { linkEvent } from 'intact-vue-next';
import { context as TableContext } from './useColumns';
import { context as ResizableContext } from './useResizable';
import { context as FixedColumnsContext } from './useFixedColumns';
import { stopPropagation } from '../utils';
import { Input } from '../input';
import { _$ } from '../../i18n';
import { ignoreSortable } from './useSortable';
export default function ($props, $blocks, $__proto__) {
  var _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    title = _this$get.title,
    fixed = _this$get.fixed,
    group = _this$get.group,
    multiple = _this$get.multiple,
    key = _this$get.key,
    sortable = _this$get.sortable,
    cols = _this$get.cols,
    rows = _this$get.rows,
    hidden = _this$get.hidden,
    hideGroupHeader = _this$get.hideGroupHeader;
  var _this$group = this.group,
    onSelect = _this$group.onSelect,
    isChecked = _this$group.isChecked,
    keywords = _this$group.keywords,
    filteredGroup = _this$group.filteredGroup,
    onShow = _this$group.onShow,
    reset = _this$group.reset,
    confirm = _this$group.confirm,
    dropdownRef = _this$group.dropdownRef,
    localGroupValue = _this$group.localGroupValue,
    isEmptyValue = _this$group.isEmptyValue,
    checkAll = _this$group.checkAll;
  var k = this.config.k;
  return _$cc(TableContext.Consumer, {
    'children': function children(checkType) {
      return _$cc(GroupContext.Consumer, {
        'children': function children(_ref) {
          var currentGroup = _ref.group,
            onChange = _ref.onChange;
          return _$cc(SortableContext.Consumer, {
            'children': function children(_ref2) {
              var sort = _sortInstanceProperty(_ref2),
                onChangeSort = _ref2.onChange;
              return _$cc(ResizableContext.Consumer, {
                'children': function children(_ref3) {
                  var resizable = _ref3.resizable,
                    onStart = _ref3.onStart;
                  return _$cc(FixedColumnsContext.Consumer, {
                    'children': function children(offsetMap) {
                      var _classNameObj, _$cn2, _$cn4;
                      var _getClassAndStyleForF = getClassAndStyleForFixed(_this.get(), offsetMap[key], k, checkType),
                        className = _getClassAndStyleForF.className,
                        style = _getClassAndStyleForF.style;
                      var classNameObj = (_classNameObj = {}, _classNameObj[k + "-column-sortable"] = sortable, _classNameObj[k + "-hidden"] = hidden, _classNameObj[className] = className, _classNameObj);
                      var groupValue = currentGroup && currentGroup[key];
                      var type = sort && sort.key === key && sort.type;
                      var checked;
                      return _$ce(2, 'th', [resizable && _this.$vNode.props.prevVNode ? _$ce(2, 'div', null, 1, _$cn(k + "-table-resize"), {
                        'ev-mousedown': function evMousedown(e) {
                          e._vNode = _this.$vNode;
                          onStart(e);
                        },
                        'ev-click': ignoreSortable
                      }) : undefined, _$ce(2, 'div', [_$ce(2, 'div', (_$blocks['title'] = function ($super) {
                        return title;
                      }, __$blocks['title'] = function ($super, data) {
                        var block = $blocks['title'];
                        var callBlock = function callBlock() {
                          return _$blocks['title'].call($this, $super, data);
                        };
                        return block ? block.call($this, callBlock, data) : callBlock();
                      }, __$blocks['title'](_$no)), 0, _$cn(k + "-table-title-text c-ellipsis")), group ? _$cc(Dropdown, {
                        'position': {
                          my: 'left top',
                          at: 'left bottom+5',
                          collision: 'flipfit'
                        },
                        'key': 'dropdown',
                        'trigger': 'click',
                        'ev-show': function evShow() {
                          return onShow(groupValue);
                        },
                        'ref': dropdownRef,
                        'children': [_$cc(Icon, {
                          'className': _$cn(k + "-icon-down-squared " + k + "-table-group"),
                          'ev-click': ignoreSortable,
                          'hoverable': true,
                          'color': isEmptyValue(groupValue) ? null : 'primary'
                        }), _$cc(DropdownMenu, {
                          'className': _$cn((_$cn2 = {}, _$cn2[k + "-table-group-dropdown"] = true, _$cn2[makeGroupMenuStyles(k)] = true, _$cn2)),
                          'children': [!hideGroupHeader ? _$ce(2, 'div', _$cc(Input, {
                            'size': 'small',
                            'fluid': true,
                            'placeholder': _$('请输入关键字'),
                            'value': keywords.value,
                            'ev-$change:value': keywords.set,
                            'clearable': true,
                            '$blocks': function ($blocks) {
                              var _$blocks = {},
                                __$blocks = _$ex({}, $blocks);
                              return (_$blocks['suffix'] = function ($super) {
                                return _$cc(Icon, {
                                  'className': _$cn(k + "-icon-search")
                                });
                              }, __$blocks['suffix'] = function ($super, data) {
                                var block = $blocks['suffix'];
                                var callBlock = function callBlock() {
                                  return _$blocks['suffix'].call($this, $super, data);
                                };
                                return block ? block.call($this, callBlock, data) : callBlock();
                              }), __$blocks;
                            }.call($this, _$em)
                          }), 2, _$cn(k + "-table-group-header")) : undefined, _$ce(2, 'div', _$ma(filteredGroup.value, function ($value, $key) {
                            var _$cn3;
                            return _$cc(DropdownItem, {
                              'ev-select': function evSelect() {
                                return onSelect($value.value, onChange);
                              },
                              'hideOnSelect': !multiple,
                              'className': _$cn((_$cn3 = {}, _$cn3[k + "-active"] = checked = isChecked($value.value), _$cn3)),
                              'children': multiple ? _$cc(Checkbox, {
                                'value': checked,
                                'children': $value.label
                              }) : _$ce(2, 'span', $value.label, 0)
                            });
                          }, $this), 4, _$cn(k + "-table-group-body")), multiple ? _$ce(2, 'div', [_$cc(Button, {
                            'size': 'mini',
                            'type': 'link',
                            'ev-click': checkAll,
                            'children': _$('全选')
                          }), _$cc(Button, {
                            'size': 'small',
                            'disabled': isEmptyValue(localGroupValue.value),
                            'ev-click': function evClick() {
                              return reset(onChange);
                            },
                            'children': _$('重置')
                          }), _$cc(Button, {
                            'type': 'primary',
                            'size': 'small',
                            'ev-click': function evClick() {
                              return confirm(onChange);
                            },
                            'children': _$('确定')
                          })], 4, _$cn(k + "-table-group-footer")) : undefined]
                        })]
                      }, 'dropdown', dropdownRef) : undefined, sortable ? _$ce(2, 'div', [_$cc(Icon, {
                        'className': _$cn(k + "-icon-up-bold " + k + "-asc"),
                        'size': 'mini'
                      }), _$cc(Icon, {
                        'className': _$cn(k + "-icon-down-bold " + k + "-desc"),
                        'size': 'mini'
                      })], 4, _$cn((_$cn4 = {}, _$cn4[k + "-column-sort"] = true, _$cn4[k + "-" + type] = type, _$cn4))) : undefined], 0, _$cn(k + "-table-title"))], 0, _$cn(classNameObj), {
                        'style': style,
                        'title': isStringOrNumber(title) ? title : null,
                        'ev-click': sortable ? linkEvent(key, onChangeSort) : null,
                        'colspan': cols,
                        'rowspan': rows
                      }, null, _this.elementRef);
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
  });
}
;